import { FC, useCallback, useEffect, useRef, useState } from 'react';
import { headerStore } from '@modules/header/adapter/outbound/stores/header.store';
import { trendsForYouStore } from '@modules/home/adapter/outbound/stores/trendsForYou.store';
import { HeaderLayoutLogic } from '@components/header';
import { AutoHideContainer } from '@components/header/HeaderLayout.style';
import MainMenuMobileLogic from '@components/header/mainMenu/mobile/mainMenu/MainMenuMobile.logic';
import HeaderOverlay from '@components/header/overlay/HeaderOverlay';
import SearchBoxLogic from '@components/search/searchBox/SearchBox.logic';
const HeaderProvider: FC = () => {
  const {
    isHeaderHidden,
    shouldForceHideHeader,
    setShouldForceHideHeader,
    isGinARaiDeeMenuOpen,
    setIsGinARaiDeeMenuOpen,
    isSearchModalOpen,
    setIsSearchModalOpen,
    isMenuMobileOpen,
    setIsMenuMobileOpen
  } = headerStore(state => state);
  const headerRef = useRef<HTMLDivElement>(null);
  const {
    resetTrendsPopoverState
  } = trendsForYouStore(state => state);
  const [scrollPosition, setScrollPosition] = useState<number>(0);
  const searchInputId = document.getElementById('mainSearchInput');
  const showHeader = () => {
    headerRef.current.style.visibility = 'visible';
    headerRef.current.style.transform = 'translateY(0%)';
  };
  const hideHeader = () => {
    headerRef.current.style.transform = 'translateY(-110%)';
    headerRef.current.style.visibility = 'hidden';
  };
  const handleNavigation = useCallback((e: {
    currentTarget: any;
  }) => {
    const window = e.currentTarget;
    const documentHeight = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight);
    const windowHeight = window.innerHeight;
    const maxHeight = documentHeight - windowHeight;
    if (scrollPosition > window.scrollY) if (isHeaderHidden) hideHeader();else showHeader();
    if (scrollPosition < window.scrollY) hideHeader();
    if (window.scrollY <= 0) showHeader();
    if (window.scrollY >= maxHeight) hideHeader();
    setScrollPosition(window.scrollY);
  }, [scrollPosition]);
  useEffect(() => {
    if (shouldForceHideHeader) hideHeader();
    if (!shouldForceHideHeader) showHeader();
  }, [shouldForceHideHeader]);
  useEffect(() => {
    setScrollPosition(window.scrollY);
    window.addEventListener('scroll', handleNavigation);
    setShouldForceHideHeader(false);
    return () => window.removeEventListener('scroll', handleNavigation);
  }, [handleNavigation]);
  const onClickOverlay = () => {
    setIsSearchModalOpen(false);
    setIsMenuMobileOpen(false);
    setIsGinARaiDeeMenuOpen(false);
    if (searchInputId) searchInputId.style.display = 'none';
  };
  return <div onClick={resetTrendsPopoverState}>
            <AutoHideContainer ref={headerRef}>
                <HeaderLayoutLogic />
                <SearchBoxLogic />
                <MainMenuMobileLogic />
            </AutoHideContainer>

            <HeaderOverlay isOpen={isGinARaiDeeMenuOpen || isSearchModalOpen || isMenuMobileOpen} onClick={onClickOverlay} />
        </div>;
};
export default HeaderProvider;